import { HomeAlbumTable } from './HomeAlbumTable';
export default HomeAlbumTable;
